module.exports = __webpack_public_path__ + "static/img/7.2dd37c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/eng/7.png
// module id = yVcc
// module chunks = 0